import PaperIcon from '@/common/assets/icons/paperIcon.svg?react';
import SmallCarIcon from '@/common/assets/icons/smallCarIcon.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import SwitchTab from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab';
import CulpritAttachedVehicleImagesTab from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/images/customerImages/attachmentImages/CulpritCustomerAttachedVehicleImagesTab';
import CustomerDocumentImagesTab from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/images/customerImages/attachmentImages/CustomerDocumentImagesTab';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="مقصر / تصاویر" header="titleHeader" hasBottomPadding>
      <CustomerAttachedImages />
    </MainLayout>
  );
};

const CustomerAttachedImages = () => {
  const [activeTab, setActiveTab] = useState(1);

  const tabs = [
    {
      title: 'تصاویر وسیله‌نقلیه',
      activeTabIndex: 1,
      icon: <SmallCarIcon stroke={'currentColor'} />,
    },
    {
      title: 'تصاویر مدارک',
      activeTabIndex: 2,
      icon: <PaperIcon stroke={'currentColor'} />,
    },
  ];
  return (
    <Box mt="5.5rem">
      <TitleDescription>تصاویر الحاقی</TitleDescription>
      <Box mt="24px">
        <SwitchTab
          activeTab={1}
          tabs={tabs}
          getActiveTab={(activeTab: number) => setActiveTab(activeTab)}
        />
        {activeTab === 1 ? <CulpritAttachedVehicleImagesTab /> : null}
        {activeTab === 2 ? <CustomerDocumentImagesTab /> : null}
      </Box>
    </Box>
  );
};
